<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form *ngIf="isPartnerForm" class="dialog-body" [formGroup]="form" (ngSubmit)="onAccept()">
  <div class="grid grid--two">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>ID</mat-label>
      <input
        matInput
        formControlName="id"
        placeholder="unique_id"
        autocomplete="off"
        autocapitalize="off"
        spellcheck="false" />
      <mat-hint *ngIf="mode==='createPartner'">Alfanumérico, guion o guion bajo. Debe ser único.</mat-hint>
      <mat-icon matSuffix *ngIf="mode==='createPartner' && f.id.touched && f.id.hasError('notUnique')" color="warn">error</mat-icon>
      <mat-icon matSuffix *ngIf="mode==='createPartner' && f.id.touched && f.id.valid">check_circle</mat-icon>
      <mat-error *ngIf="f.id.hasError('required')">Required</mat-error>
      <mat-error *ngIf="f.id.hasError('pattern')">Invalid format</mat-error>
      <mat-error *ngIf="f.id.hasError('notUnique')">ID already exists</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" placeholder="Partner name" />
      <mat-error *ngIf="f.name.hasError('required')">Required</mat-error>
      <mat-error *ngIf="f.name.hasError('maxlength')">Too long</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100 grid--full">
      <mat-label>FPD Secret</mat-label>
      <input matInput formControlName="firstPartyDataSecretKey" placeholder="Optional secret" />
    </mat-form-field>
  </div>

  <section class="adv-section">
    <header class="adv-header">
      <div class="adv-title">
        Advertisers <span class="count-pill">{{ advertisersFA.length }}</span>
      </div>
      <button type="button" class="ttd-btn ttd-btn--primary" (click)="addAdvertiser()">
        <mat-icon class="ttd-btn__icon">add</mat-icon>
        Add advertiser
      </button>
    </header>

    <div formArrayName="advertisers">
      <div class="adv-row"
           *ngFor="let g of advertisersFA.controls; let i = index; trackBy: trackByIndex"
           [formGroupName]="i">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Advertiser ID</mat-label>
          <input matInput formControlName="id" placeholder="adv_id" />
          <mat-hint>Alfanumérico, guion o guion bajo</mat-hint>
          <mat-error *ngIf="g.get('id')?.hasError('required')">Required</mat-error>
          <mat-error *ngIf="g.get('id')?.hasError('pattern')">Invalid format</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Advertiser Name</mat-label>
          <input matInput formControlName="name" placeholder="Advertiser name" />
          <mat-error *ngIf="g.get('name')?.hasError('required')">Required</mat-error>
          <mat-error *ngIf="g.get('name')?.hasError('maxlength')">Too long</mat-error>
        </mat-form-field>

        <button type="button" class="ttd-btn ttd-btn--ghost ttd-btn--danger remove-btn"
                (click)="removeAdvertiser(i)">
          Remove
        </button>
      </div>
    </div>
  </section>

  <div class="modal-footer sticky-footer">
    <button type="submit" class="ttd-btn ttd-btn--primary" [disabled]="form.invalid || loading">
      {{ mode === 'createPartner' ? 'Create' : 'Save' }}
    </button>
    <button type="button" class="ttd-btn ttd-btn--ghost" (click)="dismiss()" [disabled]="loading">Cancel</button>
  </div>
</form>

<div *ngIf="isPartnerDelete">
  <div class="dialog-body">
    <p>You are about to delete <strong>{{ partner?.id }} - {{ partner?.name }}</strong>.</p>
    <p *ngIf="partner?.advertisers?.length; else noAdv" class="text-warning">
      This partner has {{ partner?.advertisers?.length }} advertiser{{ partner?.advertisers?.length === 1 ? '' : 's' }}.
    </p>
    <ng-template #noAdv><p class="text-muted">This partner has no advertisers.</p></ng-template>
    <p class="text-danger mb-0">This action cannot be undone.</p>
  </div>

  <div class="modal-footer sticky-footer">
    <button type="button" class="ttd-btn ttd-btn--ghost ttd-btn--danger" (click)="onAccept()" [disabled]="loading">Delete</button>
    <button type="button" class="ttd-btn ttd-btn--ghost" (click)="dismiss()" [disabled]="loading">Cancel</button>
  </div>
</div>

<form *ngIf="isAdvertiserForm" class="dialog-body" [formGroup]="advForm" (ngSubmit)="onAccept()">
  <div class="grid grid--two">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Advertiser ID</mat-label>
      <input matInput formControlName="id" placeholder="adv_id" autocomplete="off" autocapitalize="off" spellcheck="false"/>
      <mat-hint *ngIf="mode==='createAdvertiser'">Alfanumérico, guion o guion bajo</mat-hint>
      <mat-icon matSuffix *ngIf="mode==='createAdvertiser' && advForm.get('id')?.touched && advForm.get('id')?.hasError('notUnique')" color="warn">error</mat-icon>
      <mat-icon matSuffix *ngIf="mode==='createAdvertiser' && advForm.get('id')?.touched && advForm.get('id')?.valid">check_circle</mat-icon>
      <mat-error *ngIf="advForm.get('id')?.hasError('required')">Required</mat-error>
      <mat-error *ngIf="advForm.get('id')?.hasError('pattern')">Invalid format</mat-error>
      <mat-error *ngIf="advForm.get('id')?.hasError('notUnique')">ID already exists</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Advertiser Name</mat-label>
      <input matInput formControlName="name" placeholder="Advertiser name" />
      <mat-error *ngIf="advForm.get('name')?.hasError('required')">Required</mat-error>
      <mat-error *ngIf="advForm.get('name')?.hasError('maxlength')">Too long</mat-error>
    </mat-form-field>
  </div>

  <div class="modal-footer sticky-footer">
    <button type="submit" class="ttd-btn ttd-btn--primary" [disabled]="advForm.invalid || loading">
      {{ mode === 'createAdvertiser' ? 'Create' : 'Save' }}
    </button>
    <button type="button" class="ttd-btn ttd-btn--ghost" (click)="dismiss()" [disabled]="loading">Cancel</button>
  </div>
</form>

<div *ngIf="isAdvertiserDelete">
  <div class="dialog-body">
    <p>
      You are about to delete advertiser
      <strong>{{ advertiser?.id }} - {{ advertiser?.name }}</strong>
      from partner <strong>{{ partner?.id }}</strong>.
    </p>
    <p class="text-danger mb-0">This action cannot be undone.</p>
  </div>
  <div class="modal-footer sticky-footer">
    <button type="button" class="ttd-btn ttd-btn--ghost ttd-btn--danger" (click)="onAccept()" [disabled]="loading">Delete</button>
    <button type="button" class="ttd-btn ttd-btn--ghost" (click)="dismiss()" [disabled]="loading">Cancel</button>
  </div>
</div>
